module.exports = __webpack_public_path__ + "static/media/table_column_checkbox_sample_1.6055747a.png";